export default __webpack_public_path__ + "static/pexels-skitterphoto-589_-a2ec34654f7b5e9705cccba3f5a2f7d3.jpg";